module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-dialog"
  }, [_c('el-dialog', {
    attrs: {
      "title": _vm.$t('actions.project.settings.logo.title'),
      "size": "small",
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#333"
    }
  }, [_vm._v(_vm._s(_vm.$t('hint.project.logo.main')))]), _vm._v(" "), (_vm.logosLeft === 0) ? _c('el-form', [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('common.order.labels.price')
    }
  }, [_vm._v("\n        ￥ 99 / " + _vm._s(_vm.$t('common.project')) + "\n        "), _c('a', {
    staticClass: "price-link",
    attrs: {
      "href": "/price?closeOnPQuota=true",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "ppj-icon-gift"
  }), _vm._v("升级账户，100个项目去 logo 只需￥1999！")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('common.order.labels.payType')
    }
  }, [_c('el-radio-group', {
    staticClass: "payment",
    attrs: {
      "theme": "info"
    },
    model: {
      value: (_vm.payType),
      callback: function($$v) {
        _vm.payType = $$v
      },
      expression: "payType"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "wechat"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.order.wechat')))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "alipay"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.order.alipay')))])], 1)], 1)], 1) : _c('div', {
    staticClass: "has-quotas"
  }, [_c('el-checkbox', {
    attrs: {
      "theme": "info",
      "checked": true,
      "disabled": true
    }
  }, [_vm._v("\n        使用账号修改Logo额度（" + _vm._s(_vm.logosLeft === null ? '不限次数' : ("还剩" + _vm.logosLeft + "次")) + "）\n      ")])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.buttons.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.placeOrder()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.buttons.submit')))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f4a0228"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/show/setting/form/logo/order.dialog.vue
// module id = 925
// module chunks = 3